import { useState, useEffect } from 'react';
import { apiService, PortfolioItem } from '../services/api';

export const usePortfolio = () => {
  const [portfolios, setPortfolios] = useState<PortfolioItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPortfolios = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await apiService.getPortfolios();
        setPortfolios(response);
      } catch (err) {
        console.error('Failed to fetch portfolios:', err);
        setError('Failed to load portfolio. Please try again later.');
        setPortfolios(getFallbackData());
      } finally {
        setLoading(false);
      }
    };

    fetchPortfolios();
  }, []);

  return { portfolios, loading, error, refetch: () => window.location.reload() };
};

const getFallbackData = (): PortfolioItem[] => [
];
